import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/vehiculos/';
const headers = { 'Content-Type': 'multipart/form-data' };
const files = ['archivo'];

/**
 * GET Documentos Vehiculares
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDocumentosVehiculares = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/documentos/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Vehicular
  * @param {number} idVehiculo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentoVehicular = async (idVehiculo, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(`${baseURI}${idVehiculo}documentos`, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Documento Vehicular
  * @param {number} idVehiculo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentoVehicular = async (idVehiculo, values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers,
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}${idVehiculo}documentos`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Documento Vehicular
 * @param {number} id
 * @param {number} idVehiculo
 * @returns {Promise<object|boolean>}
 */
export const deleteDocumentoVehicular = async (id, idVehiculo) => {
  try {
    const response = await API.delete(`${baseURI}${idVehiculo}/documentos/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
